// Ritorna il grupppo principale se esiste, altrimenti torna il primo
export function getPrincipaleOPrimoMacroGruppo(macrogruppi) {
	const principale = macrogruppi.find(mg => mg.isPrincipale);
	return principale || macrogruppi[0];
}
